import * as React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
export default (options) => (props) => {
    const selectOptions = options ? options.selectOptions || [] : [];
    return (React.createElement(FormControl, { fullWidth: true },
        React.createElement(InputLabel, null, props.propertyOptions.displayName),
        React.createElement(Select, { value: props.value || selectOptions[0], onChange: (e) => props.setValue(e.target.value) }, selectOptions.map((selectOption) => (React.createElement(MenuItem, { key: selectOption, value: selectOption }, selectOption))))));
};
